const initFaqQuestionsToggle = () => {
    const faqToggles =
        document.querySelectorAll<HTMLButtonElement>(".faq-toggle");

    faqToggles.forEach((button) => {
        button.addEventListener("click", () => {
            const content = button.nextElementSibling as HTMLElement | null;
            const icon = button.querySelector<SVGElement>("svg");

            if (!content || !icon) return;

            if (content.style.maxHeight && content.style.maxHeight !== "0px") {
                content.style.maxHeight = "0px";
                content.style.opacity = "0";
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
                content.style.opacity = "1";
            }

            icon.classList.toggle("rotate-180");
        });
    });
};

initFaqQuestionsToggle();
